import React, { useState } from "react";
import { toast } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
// import { API, deleteCall } from "../../../../config";
import Spin from "../../../common/Spin";
import { API, deleteCall } from "../../../../config";

const DeleteParagrah = ({
  paragrahId,
  toggleDeleteModal,
  handleDelete,
  showDelete,
}) => {
  const [loading, setLoading] = useState(false);

  const handleParagrahDelete = async () => {
    try {
      setLoading(true);
      const { data } = await deleteCall(`${API.DELETE_STANDARD_PARAGRAH}/${paragrahId}`);
      setLoading(false);
      toast.success(data?.message);
      handleDelete();
      toggleDeleteModal();
    } catch (e) {
      setLoading(false);
      return null;
    }
  };
  return (
    <Modal
      size="lg"
      show={showDelete}
      onHide={toggleDeleteModal}
      dialogClassName="modal-50w small-popup review-popup small-review"
      aria-labelledby="contained-modal-title-vcenter"
      className="business-section"
      centered
    >
      <Modal.Header className="mb-0" closeButton>
        Delete Standard Paragrah
      </Modal.Header>
      <Modal.Body>
        {loading && <Spin />}
        <div className="modal-body">
          Are you sure you want to delete this Standard Paragraph?
        </div>
        <div className="modal-footer">
          <Button
            type="Button"
            className="btn btn-secondary"
            onClick={() => {
              toggleDeleteModal();
            }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            className="btn btn-primary"
            data-dismiss="modal"
            onClick={() => {
              handleParagrahDelete();
            }}
          >
            OK
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteParagrah;
